"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Formatters = exports.Messages = exports.CurrentMessageLocale = exports.LocaleData = exports.getCurrentMessageLocale = exports.getLocalizeFormat = void 0;
/* istanbul ignore next */
function getLocalize() {
    var globalContainer;
    if (typeof process !== 'undefined' && typeof process.release !== 'undefined' && process.release.name === 'node') {
        globalContainer = global;
    }
    else {
        //@ts-ignore
        globalContainer = self;
    }
    var localizeNamespace = globalContainer;
    if (typeof CustomLocalizeNamespace === 'string') {
        localizeNamespace = globalContainer[CustomLocalizeNamespace];
    }
    if (typeof localizeNamespace.Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return localizeNamespace.Localize;
}
;
/* istanbul ignore next */
var getLocalizeFormat = function () {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
};
exports.getLocalizeFormat = getLocalizeFormat;
/* istanbul ignore next */
var getCurrentMessageLocale = function () {
    var localize = getLocalize();
    if (localize.message.currentLocale === undefined) {
        throw Error('The localize.message.currentLocale has not been set');
    }
    return localize.message.currentLocale;
};
exports.getCurrentMessageLocale = getCurrentMessageLocale;
/* istanbul ignore next */
exports.LocaleData = { get: function () { return exports.getLocalizeFormat().localeData; } };
/* istanbul ignore next */
exports.CurrentMessageLocale = { get: function () { return exports.getCurrentMessageLocale(); } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    CertificationIcon: function () { return t('@tableau__certification-watermark/CertificationIcon'); },
    CertifiedBy: function () { return t('@tableau__certification-watermark/CertifiedBy'); },
    CertifiedDatasource: function () { return t('@tableau__certification-watermark/CertifiedDatasource'); },
    CertifiedDatasourceLive: function () { return t('@tableau__certification-watermark/CertifiedDatasourceLive'); },
    DataConnectionIcon: function () { return t('@tableau__certification-watermark/DataConnectionIcon'); },
    ExternalServerConnectionIcon: function () { return t('@tableau__certification-watermark/ExternalServerConnectionIcon'); },
    FileConnectionIcon: function () { return t('@tableau__certification-watermark/FileConnectionIcon'); },
    LiveConnection: function () { return t('@tableau__certification-watermark/LiveConnection'); },
    LastExtract: function () { return t('@tableau__certification-watermark/LastExtract'); },
    NoDataConnections: function () { return t('@tableau__certification-watermark/NoDataConnections'); },
    SeeMoreDetails: function () { return t('@tableau__certification-watermark/SeeMoreDetails'); },
    TableauServerConnectionIcon: function () { return t('@tableau__certification-watermark/TableauServerConnectionIcon'); },
    CertifiedTableauServerConnectionIcon: function () { return t('@tableau__certification-watermark/CertifiedTableauServerConnectionIcon'); },
    ThisWorkbookConnectsTo: function () { return t('@tableau__certification-watermark/ThisWorkbookConnectsTo'); },
};
exports.Formatters = {
    formatMediumDateTimeWithoutMinutes: function (a) { return exports.getLocalizeFormat().formatDate(a, { "skeleton": "yMMMdj" }); },
    formatCount: function (a) { return exports.getLocalizeFormat().formatNumber(a, { "maximumFractionDigits": 0 }); },
};
//# sourceMappingURL=Localize.js.map